export default [
  {
    id: '6',
    parentId: '0',
    title: '用户信息',
    path: '/brands/user',
    type: 2,
    component: '/comm-pages/mine/mine',
    isHidden: true,
    icon: 'kl-team'
  }
]
